var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62388 19.6108C6.62388 19.6108 1.41334 34.7526 10.7002 33.4081C19.9871 32.0636 33.5553 42.4928 35.0459 29.7907C36.5381 17.0886 34.2713 5.56252 29.479 4.38481C24.6867 3.2071 12.7294 0.28603 6.62388 19.6108Z",
    fill: "#B49D70",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35157 13.0029C8.45164 14.797 8.96227 15.9076 9.71007 16.592C9.34495 16.8639 9.13327 17.3204 9.21099 17.814C9.59256 20.237 10.5465 25.3624 12.5021 31.1396C12.8908 32.2879 14.4431 32.2879 14.8318 31.1396C16.7873 25.3624 17.7413 20.237 18.1229 17.814C18.2006 17.3204 17.9889 16.864 17.6238 16.592C18.3716 15.9076 18.8822 14.797 18.9822 13.0029C19.0028 12.6353 18.7008 12.3325 18.3326 12.3378C17.2472 12.3534 16.3852 12.4193 15.7126 12.6454C15.435 11.9131 14.8746 11.2218 14.0311 10.5907C13.8156 10.4294 13.5182 10.4294 13.3027 10.5907C12.4661 11.2167 11.9078 11.9019 11.628 12.6275C10.9749 12.4349 10.1197 12.3585 9.00291 12.339C8.63477 12.3325 8.33106 12.6353 8.35157 13.0029ZM14.9208 14.3182L14.4659 13.118C14.3399 12.7858 14.0937 12.4121 13.6669 12.0179C13.2446 12.4079 12.9991 12.7779 12.872 13.1074L12.4297 14.2541L11.2508 13.9064C10.903 13.8039 10.4282 13.7354 9.76101 13.699C9.95922 14.9844 10.4356 15.5276 10.87 15.8085C11.491 16.2102 12.3958 16.3323 13.647 16.3336H13.6868C14.938 16.3323 15.8428 16.2102 16.4638 15.8085C16.8986 15.5273 17.3755 14.9833 17.5734 13.6953C16.9268 13.7291 16.473 13.7965 16.1375 13.9092L14.9208 14.3182ZM10.5376 17.6669H16.7962C16.6052 18.8719 16.2736 20.7331 15.7497 23.0003H13.0002V24.3336H15.4302C14.9697 26.1885 14.3898 28.2553 13.6669 30.4203C13.4308 29.713 13.2098 29.016 13.0034 28.3336H13.6668V27.0003H12.6126C11.9742 24.751 11.4966 22.6989 11.1475 21.0003H13.0002V19.667H10.8851C10.7378 18.8828 10.6235 18.2086 10.5376 17.6669Z",
    fill: "url(#paint0_linear_1786_44884)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4951 23.6861C30.8523 23.7754 31.0695 24.1373 30.9802 24.4945C30.5872 26.0667 29.4007 27.2532 27.8285 27.6463C27.4713 27.7356 27.1093 27.5184 27.0201 27.1612C26.9307 26.804 27.1479 26.4421 27.5051 26.3527C28.5996 26.0791 29.4131 25.2656 29.6867 24.1711C29.776 23.8139 30.1379 23.5968 30.4951 23.6861Z",
    fill: "url(#paint1_linear_1786_44884)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7672 19.0183C26.028 17.2897 26.1561 15.4534 27.4714 14.1381L26.5286 13.1953C24.9757 14.7482 24.706 16.7802 25.2269 18.6472C22.1764 17.2671 19 19.8052 19 23.6667C19 27.3486 22.2833 30.3334 26.3333 30.3334C30.3834 30.3334 33.6667 27.3486 33.6667 23.6667C33.6667 19.5199 30.0037 16.8994 26.7672 19.0183ZM26.3333 21.0408L25.5004 20.3745C24.2618 19.3836 23.0415 19.4386 22.1173 20.0094C21.1403 20.6129 20.3333 21.905 20.3333 23.6667C20.3333 26.4954 22.8972 29 26.3333 29C29.7695 29 32.3333 26.4954 32.3333 23.6667C32.3333 21.905 31.5264 20.6129 30.5493 20.0094C29.6252 19.4386 28.4049 19.3836 27.1663 20.3745L26.3333 21.0408Z",
    fill: "url(#paint2_linear_1786_44884)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6665 17.0003C29.6665 17.0003 30.9998 15.667 30.9998 13.667C28.9998 13.667 27.6665 15.0003 27.6665 17.0003Z",
    fill: "url(#paint3_linear_1786_44884)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1786_44884",
    x1: 8.35059,
    y1: 10.4697,
    x2: 25.447,
    y2: 18.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1786_44884",
    x1: 27,
    y1: 23.666,
    x2: 31,
    y2: 27.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1786_44884",
    x1: 19,
    y1: 13.1953,
    x2: 35.9313,
    y2: 27.6877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1786_44884",
    x1: 27.6665,
    y1: 13.667,
    x2: 30.9995,
    y2: 17.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/Food.a3342fd5f7a5e605bbb2a0a16cc7e688.svg";
export { ForwardRef as ReactComponent };